type TypingDotsProps = {
  // Optional text shown beside the dots (e.g. "Generating response…").
  label?: string;
};

// Three bouncing dots used while a response is pending or streaming with no
// content yet. Shared by the awaiting indicator and the empty streaming turn.
export default function TypingDots({ label }: TypingDotsProps) {
  return (
    <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-500">
      <span className="tw-flex tw-gap-1" aria-hidden="true">
        <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-primary-purple-400 tw-animate-bounce" style={{ animationDelay: "0ms" }} />
        <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-primary-purple-400 tw-animate-bounce" style={{ animationDelay: "150ms" }} />
        <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-primary-purple-400 tw-animate-bounce" style={{ animationDelay: "300ms" }} />
      </span>
      {label && <span>{label}</span>}
    </span>
  );
}
